import { render, staticRenderFns } from "./ConfirmNotification.vue?vue&type=template&id=38778172&scoped=true"
import script from "./ConfirmNotification.vue?vue&type=script&lang=js"
export * from "./ConfirmNotification.vue?vue&type=script&lang=js"
import style0 from "./ConfirmNotification.vue?vue&type=style&index=0&id=38778172&prod&lang=scss"
import style1 from "./ConfirmNotification.vue?vue&type=style&index=1&id=38778172&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38778172",
  null
  
)

export default component.exports